import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";
import { toast } from "react-toastify";

const deleteAdvancedSurveyResponse = async ({ advancedResponseId }) => {
  const token = localStorage.getItem("token");

  await axios.delete(`${__API_URL__}/api/survey/advanced-survey-responses/${advancedResponseId}/`, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });
};

const useRetakeAdvancedSurveyMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteAdvancedSurveyResponse,
    onSuccess: (_, variables) => {
      // Refresh survey list after retake
      queryClient.invalidateQueries({
        queryKey: ["advanced-survey-responses"],
      });
      toast.success("Survey marked for retake");
    },
    onError: (error) => {
      const message =
        error?.response?.data?.error || "Something went wrong while retaking the survey";

      toast.error(message);
    },
  });
};

export default useRetakeAdvancedSurveyMutation;
